import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Order } from 'src/app/model/interfaces/order';
import { Share } from 'src/app/model/interfaces/share';
import { UpsaleRepository } from '../infrastructure/repositories/upsale.repository';
import { RecurringUpsaleResponse } from '../model/interfaces/RecurringUpsaleResponse';
import { UpsaleTicketReservation } from '../model/interfaces/UpsaleTicketReservation';
import { PaymentInterval } from '../../model/types/payment-interval';


@Injectable()
export class UpsaleService
{
    private upsaleRepository: UpsaleRepository;

    public constructor(upsaleRepository: UpsaleRepository)
    {
        this.upsaleRepository = upsaleRepository;
    }

    public addSharedReservation(orderId: number, lotteryClass: number, share: Share): Observable<Order>
    {
        return this.upsaleRepository.addSharedReservation(orderId, lotteryClass, share);
    }

    public getTicketReservation(playerId: number, ticketNumber: number, ticketLetter: string): Observable<UpsaleTicketReservation>
    {
        return this.upsaleRepository.getTicketReservation(playerId, ticketNumber, ticketLetter);
    }

    public getNeighbourTicketReservation(playerId: number, ticketNumber: number): Observable<UpsaleTicketReservation>
    {
        return this.upsaleRepository.getNeighbourTicketReservation(playerId, ticketNumber);
    }

    public postRecurringUpsalepostRecurringUpsale(
        playerId: number,
        ticketNumber: number,
        ticketLetter: string,
        classCount: PaymentInterval,
        regNumber: number,
        accountnumber: number,
        crpDate: string,
        cprControlDigits: string
    ): Observable<RecurringUpsaleResponse>
    {
        return this.upsaleRepository.postRecurringUpsale(playerId, ticketNumber, ticketLetter, classCount, regNumber, accountnumber, crpDate, cprControlDigits);
    }
}
